import { useState, useEffect } from 'react';
import { projectURL } from './utils/mockdata';
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const RadarChart = () => {

    const [mxUser, setMxUser] = useState([]);

    const loggedUserId = sessionStorage.getItem("loggedUserId") === '682869c8f03aafcb8b90e2b5' ? '' : sessionStorage.getItem("loggedUserId");

    useEffect(() => {
        const maxActive = async () => {
            const userData = projectURL + "dashboard/most-active-users?created_by=" + loggedUserId;
            const userList = await fetch(userData, {
                headers: { "cors": "no-cors" }
            });
            const userJson = await userList.json();
            setMxUser(userJson);
        };
        maxActive();
    }, [loggedUserId]);

    const userName = mxUser.map((data) => ({
        name: data.username
    })).map((data) => data.name);

    const dataMap = mxUser.map((data) => ({
        postsCount: data.data.postsCount,
        commentsCount: data.data.commentsCount,
        likesCount: data.data.likesCount,
    })).map((data) => [
        data.postsCount,
        data.commentsCount,
        data.likesCount,
    ]);

    const getRandomColor = () => {
        const r = Math.floor(Math.random() * 76 + 180); // Range between 180 and 255
        const g = Math.floor(Math.random() * 76 + 180); // Range between 180 and 255
        const b = Math.floor(Math.random() * 76 + 180); // Range between 180 and 255
        const a = (Math.random() * 0.5 + 0.3).toFixed(2); // Transparency between 0.3 and 0.8
        return {
            bg: `rgba(${r}, ${g}, ${b}, ${a})`,
            border: `rgba(${r}, ${g}, ${b}, 1)`
        };
    };

    const colorPalette = Array.from({ length: mxUser.length }, () => getRandomColor());

    const dataSet = dataMap.map((data, index) => {
        const color = colorPalette[index % colorPalette.length];
        return {
            label: userName[index],
            data: data,
            backgroundColor: color.bg,
            borderColor: color.border,
            borderWidth: 2,
            pointBackgroundColor: color.border,
        };
    });

    const data = {
        labels: ['Post', 'Comment', 'Like'],
        datasets: dataSet,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Social Performace (Radar Chart)',
            },
        },
        scales: {
            r: {
                angleLines: { display: true },
                suggestedMin: 0,
                suggestedMax: 5,
            },
        },
    };

    return <Radar data={data} options={options} />;
};

export default RadarChart;
